// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_RTu","cls2":"LoggedOutDiscoveryPage-cls2_3kT LoggedOutDiscoveryPage-cls1_RTu"};